import React, { useState, useEffect, useRef } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { Switch } from "@headlessui/react";
import { ThreeDot } from "react-loading-indicators";
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";
import { baseUrl } from "../../Environments/environment";
import { useProperty } from "../../Contexts/PropertyContext/PropertyContext";
import { useAuth } from "../../Contexts/AuthContext/AuthContext";

import { toast } from "react-toastify";
import countries from "../../utils/countries";
import { apiClient } from "../../api";
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const statusoptions = [
  { id: 1, text: "Reservation" },
  { id: 2, text: "In House" },
  { id: 3, text: "Checked Out" },
];
let ArrivalDate = null;
let ArrivalTime = null;
let DepartureDate = null;
let DepartureTime = null;

let todayDate = null;
let tomorrowDate = null;
let standardCheckInTime = null;
let standardCheckOutTime = null;
const statuses = [
  "Bookings",
  "Check In",
  "In House",
  "Check Out",
  "Checked Out",
];

const mapStatus = {
  Booking: "Reservation",
  "Check In": "Reservation",
  "In House": "In House",
  "Check Out": "In House",
  "Checked Out": "Checked Out",
};

const reverseMapStatus = {
  Reservation: "Booking",
  "In House": "In House",
  "Checked Out": "Checked Out",
  Cancelled: "Cancelled",
};
const ChangeStatusModal = ({ isOpen, onClose, guest }) => {
  const [showLoading, setShowLoading] = useState(true);
  const dropdownRef = useRef(null);
  const searchInputRef = useRef(null);
  const { accessToken } = useAuth();
  const selectedStatus = guest.status.currentStatus;
  const { selectedPropertyId, propertyTimezone, propertyName } = useProperty();
  const [selectedDiv, setSelectedDiv] = useState();
  const [currentStatus, setCurrentStatus] = useState(selectedStatus);
  const [roomNumber, setRoomNumber] = useState(undefined);
  const [selectedRoomTypeId, setSelectedRoomTypeId] = useState(undefined);
  const [selectedCountry, setSelectedCountry] = useState({
    code: guest.countryCode ? guest.countryCode : "+1",
  });
  const [countryCode, setCountryCode] = useState(guest.countryCode || "+1");
  const [searchTerm, setSearchTerm] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState(
    guest.phoneNumber || undefined
  );
  const [firstName, setFirstName] = useState(guest.firstName || undefined);
  const [lastName, setLastName] = useState(guest.lastName || undefined);
  const [arrivalDate, setArrivalDate] = useState();
  const [arrivalTime, setArrivalTime] = useState();
  const [departureDate, setDepartureDate] = useState();
  const [departureTime, setDepartureTime] = useState();
  const [sendMessage, setSendMessage] = useState(true);
  const [isMessageVisible, setIsMessageVisible] = useState(false);
  const [message, setMessage] = useState();
  const [checkInType1, setCheckInType1] = useState("Check In");
  const [checkInType2, setCheckInType2] = useState("Check Out");
  const [isLoading, setIsLoading] = useState(false);
  const [customFlows, setCustomFlows] = useState([]);
  const [roomTypes, setRoomTypes] = useState([]);
  const [selectedRoomType, setSelectedRoomType] = useState(undefined);
  const [roomNumberError, setRoomNumberError] = useState(false);
  const [roomTypeError, setRoomTypeError] = useState(false);
  const checkIn = `${arrivalDate}T${arrivalTime}Z`;
  const checkOut = `${departureDate}T${departureTime}Z`;

  useEffect(() => {
    // if (guest.draft || !guest.countryCode || !guest.phoneNumber) {
    //   setSendMessage(false);
    // } else {
    //   setSendMessage(true);
    // }

    setSendMessage(true);
    if (selectedStatus === "Reservation") {
      setSelectedDiv(0);
    } else if (selectedStatus === "In House") {
      setSelectedDiv(1);
    } else if (selectedStatus === "Checked Out") {
      setSelectedDiv(2);
    } else {
      setSelectedDiv(0); // Default value if no match
    }
    // eslint-disable-next-line
  }, [guest, isOpen, phoneNumber, countryCode]);

  useEffect(() => {
    if (guest) {
      setShowLoading(true);
      const checkIn = guest.checkIn;
      ArrivalDate = checkIn.split("T")[0];
      ArrivalTime = checkIn.split("T")[1].split(".")[0].slice(0, 5);
      const checkOut = guest.checkOut;
      DepartureDate = checkOut.split("T")[0];
      DepartureTime = checkOut.split("T")[1].split(".")[0].slice(0, 5);

      setArrivalDate(ArrivalDate);
      setArrivalTime(ArrivalTime);
      setDepartureDate(DepartureDate);
      setDepartureTime(DepartureTime);
      setPhoneNumber(guest.phoneNumber ? guest.phoneNumber : "");
      setFirstName(guest.firstName ? guest.firstName : "");
      setLastName(guest.lastName ? guest.lastName : "");
      setCountryCode(guest.countryCode ? guest.countryCode : "+1");
      setRoomNumber(guest.roomNumber ? guest.roomNumber : "");
	  setSelectedRoomTypeId(guest.roomType ? guest.roomType : undefined);
      setSelectedCountry({
        ...selectedCountry,
        code: guest.countryCode ? guest.countryCode : "+1",
      });

      setShowLoading(false);
    }
    console.log("guest", guest);
  }, [guest, isOpen]);

  useEffect(() => {
    if (guest?.roomNumber) {
      setRoomNumber(guest.roomNumber);
    }
  }, [guest, isOpen]);

  useEffect(() => {
    if (guest && guest.status.earlyCheckInStatus === "Accepted") {
      setCheckInType1("Early Check In");
    } else if (
      guest &&
      guest.status.currentStatus === "Reservation" &&
      guest.status.reservationStatus === "Cancelled"
    ) {
      setCheckInType1("Cancel Reservation");
    } else if (
      guest &&
      guest.status.currentStatus === "Reservation" &&
      guest.status.reservationStatus === "No Show"
    ) {
      setCheckInType1("No Show");
    } else {
      setCheckInType1("Check In");
    }

    if (guest && guest.status.lateCheckOutStatus === "Accepted") {
      setCheckInType2("Late Check Out");
    } else {
      setCheckInType2("Check Out");
    }
    // eslint-disable-next-line
  }, [guest, isOpen]);

  useEffect(() => {
    if (
      guest &&
      guest.status.earlyCheckInStatus === "Not Requested" &&
      checkInType1 === "Early Check In"
    ) {
      setArrivalTime("");
    } else if (
      guest &&
      guest.status.earlyCheckInStatus === "Accepted" &&
      checkInType1 === "Check In"
    ) {
      setArrivalDate(todayDate);
      setArrivalTime(standardCheckInTime);
    } else if (
      guest &&
      guest.status.earlyCheckInStatus === "Accepted" &&
      checkInType1 === "Early Check In"
    ) {
      setArrivalDate(ArrivalDate);
      setArrivalTime(ArrivalTime);
    } else if (
      checkInType1 === "Check In" ||
      checkInType1 === "Cancel Reservation" ||
      checkInType1 === "No Show"
    ) {
      setArrivalDate(ArrivalDate);
      setArrivalTime(ArrivalTime);
    }
  }, [guest, checkInType1]);

  const setTiming = async () => {
    try {
      if (!standardCheckInTime || !standardCheckOutTime) {
        const response = await apiClient.get(
          `${baseUrl}/setting/${selectedPropertyId}`
        );
        if (response.ok) {
          const newToken = response.headers.get("Authorization");
          if (newToken) {
            localStorage.setItem("accessToken", newToken.split(" ")[1]); // Save the new token
          }
        }
        standardCheckInTime = response.data.result.setting.standardCheckinTime;
        standardCheckOutTime =
          response.data.result.setting.standardCheckoutTime;
      }
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click is outside both the dropdown and the trigger button
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
        setSearchTerm("");
      }
    };

    // Only add the event listener if the dropdown is open
    if (isDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen]);

  useEffect(() => {
    setTiming();
    // eslint-disable-next-line
  }, [isOpen]);

  useEffect(() => {
    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);

    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    todayDate = formatDate(today);
    tomorrowDate = formatDate(tomorrow);
  }, [isOpen]);

  useEffect(() => {
    if (
      guest &&
      guest.status.lateCheckOutStatus === "Not Requested" &&
      checkInType2 === "Late Check Out"
    ) {
      setDepartureTime("");
    } else if (
      guest &&
      guest.status.lateCheckOutStatus === "Accepted" &&
      checkInType2 === "Check Out"
    ) {
      setDepartureDate(tomorrowDate);
      setDepartureTime(standardCheckOutTime);
    } else if (
      guest &&
      guest.status.lateCheckOutStatus === "Accepted" &&
      checkInType2 === "Late Check Out"
    ) {
      setDepartureDate(DepartureDate);
      setDepartureTime(DepartureTime);
    } else if (
      checkInType2 === "Check Out" ||
      checkInType1 === "Cancel Reservation" ||
      checkInType1 === "No Show"
    ) {
      setDepartureDate(DepartureDate);
      setDepartureTime(DepartureTime);
    }
    // eslint-disable-next-line
  }, [guest, checkInType2]);

  const getCustomFlows = async () => {
    try {
      const response = await apiClient.get(
        `${baseUrl}/customFlow/${selectedPropertyId}`
      );
      if (response.status === 200) {
        const newToken = response.headers["authorization"];
        if (newToken) {
          localStorage.setItem("accessToken", newToken.split(" ")[1]);
        }

        if (response.data?.result?.length > 0) {
          console.log("DATAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA", response.data);
          setCustomFlows([...response.data.result].reverse());
        } else {
          console.warn("No flows found");
          //console.log(response.data.result)
          setCustomFlows([...response.data.result.customFlow].reverse());
        }
      } else {
        console.error("API error:", response);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getRoomTypes = async () => {
    try {
      const token = localStorage.getItem("accessToken");
      const response = await apiClient.get(
        `${baseUrl}/upgradeRoomWorkflow/roomType/${selectedPropertyId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        const newToken = response.headers["authorization"];
        if (newToken) {
          localStorage.setItem("accessToken", newToken.split(" ")[1]);
        }
        setRoomTypes(response.data.result.roomType);
        console.log("Room Data Fetched :", response.data.result.roomType);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getCustomFlows();
	getRoomTypes();
  }, [isOpen]);

  if (!isOpen) return null;

  const sendCustomMessages = async (status, guest) => {
    if (!customFlows || customFlows.length == 0) {
      await getCustomFlows();
    }
    console.log(customFlows);
    const filteredFlows = customFlows.filter(
      (flow) =>
        flow.trigger.toLowerCase() === "after guest moved to in-house" &&
        flow.flowStatus == true
    );

    console.log(filteredFlows);

    console.log(status);
    if (status.currentStatus === "In House") {
      for (const flow of filteredFlows) {
        const bodyData = {
          messageId: flow.messageTemplateId,
          sendMessage: true,
          status,
          guest,
        };
        try {
          const response = await apiClient.post(
            `${baseUrl}/customMessage/${selectedPropertyId}`,
            bodyData
          );
          // console.log("Response ------",response.data)
        } catch (error) {
          // console.error("-------------------------ERROR WHILE SENDING CUSTOM MESSAGE---------------",error)
        }
      }
    }
  };

  const handleChangeStatus = async () => {
    let status = { currentStatus };
    if (checkInType1 === "Early Check In") {
      status.earlyCheckInStatus = "Accepted";
    } else if (
      guest.status.earlyCheckInStatus === "Accepted" &&
      checkInType1 === "Check In"
    ) {
      status.earlyCheckInStatus = "Declined";
    }
    if (checkInType1 === "Cancel Reservation") {
      status.reservationStatus = "Cancelled";
    }
    if (checkInType1 === "No Show") {
      status.reservationStatus = "No Show";
    }
    if (checkInType2 === "Late Check Out") {
      status.lateCheckOutStatus = "Accepted";
    } else if (
      guest.status.lateCheckOutStatus === "Accepted" &&
      checkInType2 === "Check Out"
    ) {
      status.lateCheckOutStatus = "Declined";
    }
    if (
      guest.status.reservationStatus === "Cancelled" &&
      checkInType1 !== "Cancel Reservation" &&
      checkInType1 !== "No Show"
    ) {
      status.reservationStatus = "Confirmed";
    }
    if (
      guest.status.reservationStatus === "No Show" &&
      checkInType1 !== "No Show" &&
      checkInType1 !== "Cancel Reservation"
    ) {
      status.reservationStatus = "Confirmed";
    }
    let updatedGuestData = {};
    let guestId = "";
    status.currentStatus =
      status.currentStatus === "Booking"
        ? "Reservation"
        : status.currentStatus === "Checked Out"
        ? "Checked Out"
        : status.currentStatus;

    if (guest) {
      updatedGuestData = {
        email: guest.email,
        source: guest.source,
        status,
        checkIn: checkIn,
        checkOut: checkOut,
        lastName: guest.lastName,
        firstName: guest.firstName,
        countryCode: !phoneNumber ? undefined : countryCode,
        phoneNumber: phoneNumber === "" ? undefined : phoneNumber,
        // countryCode: guest.countryCode,
        // phoneNumber: guest.phoneNumber,
        confirmationNumber: guest.confirmationNumber,
        sendMessage: sendMessage,
        ...(currentStatus !== "Reservation" && { 
			roomNumber: roomNumber,
			roomType: selectedRoomTypeId ? parseInt(selectedRoomTypeId, 10) : undefined
		}),
      };
      guestId = guest._id;
    }

		// Validate room number is required for non-reservation status
		if (
			currentStatus !== "Reservation" &&
			(!roomNumber || roomNumber.trim() === "")
		) {
			setRoomNumberError(true);
			toast.error("Room number is required ");
			return;
		} else {
			setRoomNumberError(false);
		}
    // Validate room type is required for non-reservation status
    if (
      currentStatus !== "Reservation" &&
      (!selectedRoomTypeId || selectedRoomTypeId === "")
    ) {
      setRoomTypeError(true);
      toast.error("Room type is required");
      return;
    } else {
      setRoomTypeError(false);
    }

    // console.log(updatedGuestData);
    try {
      setIsLoading(true);
      // eslint-disable-next-line
      const response = await apiClient.put(
        `${baseUrl}/guest/${selectedPropertyId}/${guestId}`,
        updatedGuestData
      );
      const updatedGuest = response.data.result.guest;
      // console.log(updatedGuest)
      sendCustomMessages(updatedGuest.status, updatedGuest);
      // console.log(response.data)
      setIsLoading(false);
      if (response.ok) {
        const newToken = response.headers.get("Authorization");
        if (newToken) {
          localStorage.setItem("accessToken", newToken.split(" ")[1]); // Save the new token
        }
      }
      toast.success(response.data.message);
      setCurrentStatus(selectedStatus);

      setSendMessage(true);
      // setCountryCode("+1");
      // setPhoneNumber(undefined);
      setShowLoading(true);
      onClose();
    } catch (error) {
      setIsLoading(false);
      // console.log(error.response?.data?.error);
      let errorMessage =
        error.response?.data?.message ||
        "Failed to update the guest. Please try again.";
      if (error.response?.data?.error.checkIn !== undefined) {
        errorMessage = "For Check In " + error.response?.data?.error.checkIn[0];
      } else if (error.response?.data?.error.checkOut !== undefined) {
        errorMessage =
          "For Check Out " + error.response?.data?.error.checkOut[0];
      } else if (error.response?.data?.error.roomNumber !== undefined) {
        errorMessage = "Room number is required";
      }
      toast.error(errorMessage);
    }
  };
  const handleDivClick = (index, text) => {
    if (selectedDiv === index) {
      if (selectedStatus === "Reservation") {
        setSelectedDiv(0);
      } else if (selectedStatus === "In House") {
        setSelectedDiv(1);
      } else if (selectedStatus === "Checked Out") {
        setSelectedDiv(2);
      } else {
        setSelectedDiv(0); // Default value if no match
      }
      setCurrentStatus(selectedStatus);
    } else {
      setSelectedDiv(index);
      setCurrentStatus(text);
    }
  };

  const toggleDropdown = (e) => {
    e.stopPropagation();
    setIsDropdownOpen(!isDropdownOpen);
    if (!isDropdownOpen) {
      // Reset search when opening
      setSearchTerm("");
      // Focus search input after opening
      setTimeout(() => {
        searchInputRef.current?.focus();
      }, 0);
    }
  };
  const toggleMessageVisibility = () => {
    setIsMessageVisible(!isMessageVisible);
  };
  const filteredCountries = countries.filter((country) =>
    country.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleCountrySelect = (country) => {
    setSelectedCountry(country);
    setCountryCode(country.code);
    setSearchTerm(""); // Clear search term on selection
    setIsDropdownOpen(false); // Close the dropdown
  };

  const getRoomTypeNameById = (id) => {
	const roomType = roomTypes.find(roomType => roomType.id === id);
	return roomType ? (roomType.roomType || roomType.name) : "";
  }

  // console.log("Country selected");

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-8 rounded-lg shadow-xl lg:w-[70vh] overflow-x-auto space-y-7">
        {showLoading ? (
          <div className="flex flex-row justify-center items-center">
            <ThreeDot
              variant="brick-stack"
              color="#4f46e5"
              size="medium"
              text=""
              textColor=""
            />
          </div>
        ) : (
          <>
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-x-2">
                <h2 className="text-lg font-semibold">Update Status</h2>
                <p className="italic text-lg">{`${firstName} ${lastName}`}</p>
              </div>

              <button
                onClick={() => {
                  setCurrentStatus(selectedStatus);
                  setSendMessage(true);
                  // setCountryCode("+1");
                  // setPhoneNumber(undefined);
                  setShowLoading(true);
                  onClose();
                }}
                className="text-gray-600 hover:text-gray-900"
              >
                <AiOutlineClose size={20} />
              </button>
            </div>
            <div className="w-full space-y-7">
              <div className="flex items-center justify-between">
                {statusoptions.map((div, index) => (
                  <div
                    key={div.id}
                    className={`relative flex items-center justify-center h-[7vh] w-[19vh] p-4 border border-solid rounded-[2vh] border-[#D1D5DB] cursor-pointer text-center text-sm font-semibold ${
                      selectedDiv === index
                        ? "bg-[#EEF2FF] border-indigo-600"
                        : "bg-white text-black"
                    }`}
                    onClick={() => handleDivClick(index, div.text)}
                  >
                    {/* Chip for Current */}
                    {selectedDiv === index && (
                      <span className="absolute -top-[1.5vh] left-1/2 transform -translate-x-1/2 bg-[#FBBF24] font-medium text-black px-4 py-1 text-xs rounded-full">
                        Current
                      </span>
                    )}
                    {reverseMapStatus[div.text]}
                  </div>
                ))}
              </div>

              <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700">
                  Phone Number
                </label>
                <div className="relative">
                  <div className="flex">
                    <div className="relative w-[120px]">
                      <button
                        type="button"
                        onClick={toggleDropdown}
                        className="w-full h-full flex items-center justify-between px-3 py-2 border border-gray-300 bg-white rounded-l-md text-sm hover:bg-gray-50"
                      >
                        <span className="flex items-center gap-2">
                          {selectedCountry ? (
                            <>
                              <span>{selectedCountry.code}</span>
                            </>
                          ) : (
                            "+1"
                          )}
                        </span>
                        <svg
                          className={`w-4 h-4 text-gray-400 transition-transform duration-200 ${
                            isDropdownOpen ? "rotate-180" : ""
                          }`}
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                        </svg>
                      </button>
                    </div>
                    <input
                      type="tel"
                      value={phoneNumber}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                      placeholder="Enter phone number"
                      className="flex-1 rounded-r-md border border-l-0 border-gray-300 
                       px-3 py-2 text-sm text-gray-700 
                       focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500
                       placeholder:text-gray-400"
                    />
                  </div>

                  {/* Dropdown */}
                  {isDropdownOpen && (
                    <div
                      ref={dropdownRef}
                      className="absolute top-full left-0 mt-1 w-64 bg-white border border-gray-200 rounded-md shadow-lg z-50"
                    >
                      <div className="p-2">
                        <input
                          ref={searchInputRef}
                          type="text"
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          placeholder="Search country..."
                          className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm
                           focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500
                           placeholder:text-gray-400"
                        />
                      </div>
                      <div className="max-h-60 overflow-y-auto">
                        {filteredCountries.map((country) => (
                          <div
                            key={country.code}
                            className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex items-center gap-3 text-sm"
                            onClick={() => handleCountrySelect(country)}
                          >
                            <span className="text-lg">{country.flag}</span>
                            <span className="text-gray-700">
                              {country.name}
                            </span>
                            <span className="text-gray-500 ml-auto">
                              {country.code}
                            </span>
                          </div>
                        ))}
                        {filteredCountries.length === 0 && (
                          <div className="px-4 py-2 text-sm text-gray-500">
                            No countries found
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="w-full">
                <label className="block text-[13px] font-semibold text-black mb-1">
                  Registration Details
                </label>

                <div className="flex">
                  <div className="w-1/2">
                    <select
                      value={checkInType1}
                      onChange={(e) => setCheckInType1(e.target.value)}
                      placeholder="Car Type"
                      className={`block w-full border border-b-0 rounded-tl-md border-r-0 border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 text-black text-[13px] placeholder:text-black placeholder:font-light ${
                        checkInType1 === "Cancel Reservation" ||
                        checkInType1 === "No Show"
                          ? "bg-rose-50"
                          : ""
                      }`}
                    >
                      <option value="Check In">Check In</option>
                      <option value="Early Check In">Early Check In</option>

                      {guest.status.currentStatus === "Reservation" && (
                        <option value="Cancel Reservation">
                          Cancel Reservation
                        </option>
                      )}
                      {guest.status.currentStatus === "Reservation" && (
                        <option value="No Show">No Show</option>
                      )}
                    </select>
                  </div>
                  <div className="w-1/2">
                    <select
                      value={checkInType2}
                      onChange={(e) => setCheckInType2(e.target.value)}
                      placeholder="Car Type"
                      className="block w-full border border-b-0 rounded-tr-md border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 text-black text-[13px] placeholder:text-black placeholder:font-light"
                    >
                      <option value="Check Out">Check Out</option>
                      <option value="Late Check Out">Late Check Out</option>
                    </select>
                  </div>
                </div>

								<div className="flex mb-4">
									<div className="w-1/4">
										<input
											type="date"
											id="arrivalDate"
											value={arrivalDate}
											onChange={(e) => {
												const newArrival = e.target.value;
												setArrivalDate(newArrival);

												setDepartureDate(
													new Date(newArrival) >= new Date(departureDate)
														? new Date(
																new Date(newArrival).getTime() +
																	24 * 60 * 60 * 1000,
															)
																.toISOString()
																.split("T")[0]
														: departureDate,
												);
											}}
											className={`block w-full border border-r-0 rounded-bl-md border-gray-300 px-3 py-1 pl-1 pr-2 focus:border-indigo-500 focus:ring-indigo-500  text-[13px] ${
												checkInType1 === "Check In" ||
												checkInType1 === "Cancel Reservation" ||
												checkInType1 === "No Show"
													? "text-gray-400"
													: "text-gray-900"
											}`}
										/>
									</div>
									<div className="w-1/4">
										<input
											type="time"
											id="arrivalTime"
											value={arrivalTime}
											disabled={checkInType1 === "Check In" ? true : false}
											onChange={(e) => {
												setArrivalTime(e.target.value);
											}}
											className={`block w-full border border-l-0 border-r-0 border-gray-300 px-3 py-1 pl-1 pr-2 focus:border-indigo-500 focus:ring-indigo-500 text-[13px] ${
												checkInType1 === "Check In" ||
												checkInType1 === "Cancel Reservation" ||
												checkInType1 === "No Show"
													? "text-gray-400"
													: "text-gray-900"
											}`}
										/>
									</div>
									<div className="w-1/4">
										<input
											type="date"
											id="departureDate"
											value={departureDate}
											min={arrivalDate}
											onChange={(e) => setDepartureDate(e.target.value)}
											className={`block w-full border border-r-0 border-gray-300 px-3 py-1 pl-1 pr-2 focus:border-indigo-500 focus:ring-indigo-500 text-[13px] ${
												checkInType2 === "Check Out" ||
												checkInType1 === "Cancel Reservation" ||
												checkInType1 === "No Show"
													? "text-gray-400"
													: "text-gray-900"
											}`}
										/>
									</div>
									<div className="w-1/4">
										<input
											type="time"
											id="departureTime"
											value={departureTime}
											disabled={
												checkInType2 === "Check Out" &&
												(checkInType1 !== "Cancel Reservation" ||
													checkInType1 === "No Show")
													? true
													: false
											}
											onChange={(e) => setDepartureTime(e.target.value)}
											className={`block w-full border border-l-0 rounded-br-md border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 text-[13px] ${
												checkInType2 === "Check Out" ||
												checkInType1 === "Cancel Reservation" ||
												checkInType1 === "No Show"
													? "text-gray-400"
													: "text-gray-900"
											}`}
										/>
									</div>
								</div>

                {selectedDiv === 0 ? (
                  <></>
                ) : (
                  <>
                    <div className="w-full mt-4">
                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <label className="block text-[13px] font-semibold text-gray-700 mb-1">
                            Room Number
                          </label>
                          <input
                            type="text"
                            value={roomNumber}
                            onChange={(e) => setRoomNumber(e.target.value)}
                            className="block w-full border rounded-md border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 text-[13px] placeholder:text-gray-300 placeholder:font-light"
                          />
                        </div>
                        <div>
                          <label className="block text-[13px] font-semibold text-gray-700 mb-1">
                            Room Type
                          </label>
                          <select
                            value={selectedRoomTypeId || ""}
                            onChange={(e) => {
                              const selectedId = e.target.value;
                              setSelectedRoomTypeId(selectedId);
                              console.log("Selected Room Type ID:", selectedId);
                            }}
                            className="block w-full border rounded-md border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 text-[13px]"
                          >
                            <option value="">Select Room Type</option>
                            {roomTypes && roomTypes.length > 0 ? (
                              roomTypes.map((roomType, index) => (
                                <option
                                  key={index}
                                  value={roomType.id}
                                >
                                  {roomType.roomType || roomType.name}
                                </option>
                              ))
                            ) : (
                              <option disabled>No room types available</option>
                            )}
                          </select>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div>
              <div className="flex flex-col lg:flex-row items-center justify-between">
                {/* Switch */}
                <div className="flex items-center mb-2 lg:mb-0">
                  <Switch
                    // disabled={
                    //   guest.draft || !guest.countryCode || !guest.phoneNumber
                    // }
                    checked={sendMessage}
                    onChange={setSendMessage}
                    className={classNames(
                      sendMessage ? "bg-indigo-600" : "bg-gray-200",
                      "relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2"
                    )}
                  >
                    <span className="sr-only">Use setting</span>
                    <span
                      aria-hidden="true"
                      className={classNames(
                        sendMessage ? "translate-x-5" : "translate-x-0",
                        "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
                      )}
                    />
                  </Switch>
                  <div className="justify-start">
                    <div>
                      <label
                        htmlFor="toggle"
                        className="ml-2 text-[13px] font-medium text-[#111827]"
                      >
                        Message Guest
                      </label>
                    </div>
                    {/* <label
                  htmlFor="toggle"
                  className="ml-2 text-sm font-medium text-[#111827]"
                >
                  Message Guest
                </label> */}
                    <div className="-mt-1.5">
                      <button
                        className="text-gray-400 pl-2 text-xs"
                        onClick={toggleMessageVisibility}
                      >
                        {isMessageVisible ? (
                          <>
                            <div className="flex">
                              <div className="pr-1">Hide Message</div>
                              <IoIosArrowUp />
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="flex">
                              <div className="pr-1">View Message</div>
                              <IoIosArrowDown />
                            </div>
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                  {/* <label
                htmlFor="toggle"
                className="ml-2 text-sm font-medium text-[#111827]"
              >
                Message Guest
              </label> */}
                </div>
                {/* Add Guest Button */}
                <button
                  onClick={handleChangeStatus}
                  className={`lg:ml-2 text-white font-semibold px-4 py-2 rounded-md text-[13px] focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 ${
                    checkInType1 === "Cancel Reservation" ||
                    checkInType1 === "No Show"
                      ? "bg-rose-400 hover:bg-rose-500 focus-visible:outline-rose-400"
                      : "bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600"
                  }
                  `}
                  disabled={isLoading}
                >
                  {isLoading
                    ? "Updating..."
                    : checkInType1 === "Cancel Reservation"
                    ? "Cancel Reservation"
                    : checkInType1 === "No Show"
                    ? "No Show"
                    : `Save Changes`}
                </button>
              </div>
              <div className="w-full mt-2">
                {isMessageVisible && (
                  <textarea
                    value={
                      reverseMapStatus[currentStatus] === "Booking"
                        ? `Your reservation at ${propertyName} is confirmed! We look forward to welcoming you on ${new Date(
                            checkIn
                          ).toLocaleString("en", {
                            day: "2-digit",
                            month: "2-digit",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                            timeZone: "UTC",
                          })}${propertyTimezone}. Reply here for questions.`
                        : reverseMapStatus[currentStatus] === "In House"
                        ? `Welcome to ${propertyName}! You've successfully checked in. Enjoy your stay. Reply here for questions.`
                        : reverseMapStatus[currentStatus] === "Checked Out"
                        ? `Thank you for staying at ${propertyName}. You’ve successfully checked out. We hope to welcome you back soon. Reply here for questions.`
                        : ""
                    }
                    //onChange={(e) => setMessage(e.target.value)}
                    className="block w-full rounded-md border border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 resize-none overflow-y-auto text-[13px] placeholder:text-gray-900"
                    rows={3}
                    placeholder="Default status message template text goes here and not editable..."
                  />
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ChangeStatusModal;
